// The sync's calendar: a sync is due once per local day. The day is the
// user's, not UTC, so "a new day" is the one they see on their clock.

/** "2026-10-12" for a moment in time, in the local time zone. */
export function localDay(now: Date): string {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export interface SyncRecord {
  /** '' when no account is configured: nothing to sync. */
  username: string;
  /** The local day the last sync completed, `localDay`; undefined when none ever did. */
  lastSyncDay?: string;
  /** The local day the user chose to go on without a sync; this session only. */
  skippedDay?: string;
}

/** Whether a sync is due at `now`: an account, and neither a completed nor a skipped sync today. */
export function syncDue(record: SyncRecord, now: Date): boolean {
  if (!record.username) return false;
  const today = localDay(now);
  return record.lastSyncDay !== today && record.skippedDay !== today;
}
